import React from "react";
import clsx from "clsx";
import {Textarea, TextInput} from "flowbite-react";
import {InputText_SurveyQuestionPage_Options} from "data/models/survey/input";
import {RenderableTitle, SurveySectionsRenderingModel} from "data/models/survey/base";
import {DESCRIPTION_CLASS, QUESTION_CONTAINER_CLASS, TEXT_INPUT_THEME} from "components/Survey/classes";
import ParagraphPageComponent from "./ParagraphsSurveyQuestionPage/ParagraphPageComponent";
import {TEXT_ALIGNMENT_CLASS} from "data/models/survey/paragraphs";

export type InputText_SurveyQuestionPage_Props = {
  options: InputText_SurveyQuestionPage_Options,
  questionId: string,
  required: boolean,
  title: RenderableTitle,
  description: RenderableTitle | null,
  surveySectionsRenderingModel: SurveySectionsRenderingModel | null,
  value: string | undefined,
  onChange: (id: string, value: string) => void,
}


export default function InputTextSurveyQuestionPage(
    {
      options,
      questionId,
      required,
      title,
      description,
      surveySectionsRenderingModel,
      value,
      onChange
    }: InputText_SurveyQuestionPage_Props
) {
  return <div className={"flex flex-col w-full"}>
    <div className={QUESTION_CONTAINER_CLASS}>
      <div className={clsx("my-4", TEXT_ALIGNMENT_CLASS[options.textAlignment])}>{title}</div>
      {description !== null &&
          <div className={clsx("my-4", TEXT_ALIGNMENT_CLASS[options.textAlignment])}>{description}</div>}
      <div className={clsx(
          "mt-4",
          options.textAlignment === "center" && "mx-auto max-w-2xl",
      )}>
        {options.linesHeight === 1 && <TextInput
            theme={TEXT_INPUT_THEME}
            sizing={"lg"}
            id={questionId}
            type={options.inputType}
            placeholder={options.placeholder}
            required={required}
            value={value ?? ""}
            onChange={({target: {id, value: editValue}}) => onChange(id, editValue)}
        />}
        {options.linesHeight > 1 && <Textarea
            className={"text-base text-neutral-500 bg-neutral-50 border-0 focus:border-0 focus:ring-bc-blue focus:ring-2"}
            id={questionId}
            rows={options.linesHeight}
            placeholder={options.placeholder}
            required={required}
            value={value ?? ""}
            onChange={({target: {id, value: editValue}}) => onChange(id, editValue)}
        />}
      </div>
      <div className={TEXT_ALIGNMENT_CLASS[options.textAlignment]}>
        {options.paragraphs.map((paragraph, index) =>
            <ParagraphPageComponent
                key={index}
                title={paragraph}
                surveySectionRenderingModel={surveySectionsRenderingModel}
                defaultTitleClass={DESCRIPTION_CLASS}
            />
        )}
      </div>
    </div>
  </div>
}
